import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { loadBreedList } from '../actions';

export const usePetBreeds = () => {
  const dispatch = useDispatch();
  const store = useSelector(({ myPets }) => ({ myPets }), shallowEqual);
  const { myPets: { breedData } } = store;

  useEffect(() => {
    if (!breedData.dogBreeds.length && !breedData.catBreeds.length) {
      dispatch(loadBreedList());
    }
  }, [dispatch, breedData]);

  return {
    breedData,
  };
};
